import moment from 'moment';

/**
 * A time from the API as a moment, or null. GraphQL String timestamps arrive as
 * millisecond strings ("1696766400000"), which moment() can't parse as text;
 * ISO strings work too.
 */
const toMoment = (v?: string | null): moment.Moment | null => {
  if (!v) return null;
  const n = Number(v);
  const m = Number.isNaN(n) ? moment(v) : moment(n);
  return m.isValid() ? m : null;
};

export default toMoment;
